import React from 'react';
import { Sparkles, BookOpen, Layers, FileText, CreditCard, Play } from 'lucide-react';

interface StudySummaryProps {
    cycleCount: number;
    deckCount: number;
    subdeckCount: number;
    totalCards: number;
    onStartStudy: () => void;
}

const StudySummary: React.FC<StudySummaryProps> = ({
    cycleCount,
    deckCount,
    subdeckCount,
    totalCards,
    onStartStudy
}) => {
    return (
        <div className="study-summary-section">
            <div className="cs-summary-card">
                <div className="cs-summary-header">
                    <h3>
                        <Sparkles size={28} />
                        Resumo do Estudo Personalizado
                    </h3>
                </div>

                <div className="cs-summary-stats">
                    <div className="cs-summary-stat">
                        <div className="cs-stat-icon">
                            <BookOpen size={24} />
                        </div>
                        <div className="cs-stat-content">
                            <span className="cs-stat-value">{cycleCount}</span>
                            <span className="cs-stat-label">
                                Campo{cycleCount !== 1 ? 's' : ''}
                            </span>
                        </div>
                    </div>

                    <div className="cs-summary-stat">
                        <div className="cs-stat-icon">
                            <Layers size={24} />
                        </div>
                        <div className="cs-stat-content">
                            <span className="cs-stat-value">{deckCount}</span>
                            <span className="cs-stat-label">
                                Deck{deckCount !== 1 ? 's' : ''}
                            </span>
                        </div>
                    </div>

                    <div className="cs-summary-stat">
                        <div className="cs-stat-icon">
                            <FileText size={24} />
                        </div>
                        <div className="cs-stat-content">
                            <span className="cs-stat-value">{subdeckCount}</span>
                            <span className="cs-stat-label">
                                Subdeck{subdeckCount !== 1 ? 's' : ''}
                            </span>
                        </div>
                    </div>

                    <div className="cs-summary-stat cs-highlight">
                        <div className="cs-stat-icon">
                            <CreditCard size={24} />
                        </div>
                        <div className="cs-stat-content">
                            <span className="cs-stat-value">{totalCards}</span>
                            <span className="cs-stat-label">
                                Card{totalCards !== 1 ? 's' : ''}
                            </span>
                        </div>
                    </div>
                </div>

                <button className="cs-btn-start" onClick={onStartStudy}>
                    <Play size={22} />
                    Iniciar Estudo Personalizado
                </button>

                <p className="cs-summary-hint">
                    Você estudará flashcards dos conteúdos selecionados de forma combinada
                </p>
            </div>
        </div>
    );
};

export default StudySummary;